module.exports = {"id":"158232","name":"Salomon Kalou","rating":"80","photo":"./data/images/photos/2/158232.png","club":{"name":"Hertha Berlin","logo":"./data/images/clubs/HerthaBerlin.png"},"positions":["MG","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SalomonKalou0.json
// module id = 3780
// module chunks = 0